"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTemplate = exports.useSegment = exports.useDialogue = exports.useCell = exports["default"] = void 0;

var _react = require("react");

var _ThemeContext = require("../configProvider/ThemeContext");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useTemplate = function useTemplate(source, type) {
  var _useContext = (0, _react.useContext)(_ThemeContext.ThemeContext),
      themeData = _useContext.themeData,
      setThemeData = _useContext.setThemeData;

  var _themeData$theme$elem = themeData.theme.elements,
      cells = _themeData$theme$elem.cells,
      segmentViews = _themeData$theme$elem.segmentViews,
      views = themeData.parsedTheme.views;
  var toReturn;

  switch (source) {
    case "cell":
      {
        var cellType = _objectSpread({}, cells[type]);

        if (cellType.views === null) {
          cellType.views = {};
        }

        toReturn = cellType;
        break;
      }

    case "segmentView":
      {
        var segment = segmentViews[type];
        var view = views[segment.view];
        toReturn = {
          segment: segment,
          view: view
        };
        break;
      }

    default:
      {
        throw new Error("Please specify a source");
      }
  }

  return toReturn;
};

exports.useTemplate = useTemplate;

var useCell = function useCell(type) {
  return useTemplate("cell", type);
};

exports.useCell = useCell;

var useSegment = function useSegment(type) {
  return useTemplate("segmentView", type);
};

exports.useSegment = useSegment;

var useDialogue = function useDialogue(type) {
  return useTemplate("dialogues", type);
};

exports.useDialogue = useDialogue;
var _default = {
  useTemplate: useTemplate,
  useCell: useCell,
  useSegment: useSegment,
  useDialogue: useDialogue
};
exports["default"] = _default;